var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.486 2.5 2 6.986 2 12.5V16.643C2 17.667 2.897 18.5 4 18.5H5C5.26522 18.5 5.51957 18.3946 5.70711 18.2071C5.89464 18.0196 6 17.7652 6 17.5V12.357C6 12.0918 5.89464 11.8374 5.70711 11.6499C5.51957 11.4624 5.26522 11.357 5 11.357H4.092C4.648 7.487 7.978 4.5 12 4.5C16.022 4.5 19.352 7.487 19.908 11.357H19C18.7348 11.357 18.4804 11.4624 18.2929 11.6499C18.1054 11.8374 18 12.0918 18 12.357V18.5C18 19.603 17.103 20.5 16 20.5H14V19.5H10V22.5H16C18.206 22.5 20 20.706 20 18.5C21.103 18.5 22 17.667 22 16.643V12.5C22 6.986 17.514 2.5 12 2.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.04394f7c9735ec44ccece188ac9518bd.svg";
export { ForwardRef as ReactComponent };